const getters = {

    getCreditNoteList(state){
        return state.creditNoteList;
    },
}
export default getters;